module.exports = __webpack_public_path__ + "static/media/dosicase_logo.a5ed8b1e.png";